var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.text || _vm.data.value == 'circle-info')?_c('span',{class:['icon', _vm.data.className ? _vm.data.className : ''],attrs:{"data-balloon-length":_vm.balloon_length,"aria-label":_vm.data.text,"data-balloon-pos":"up"}},[_c('font-awesome-icon',{attrs:{"icon":_vm.data.value}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }